module.exports = __webpack_public_path__ + "static/media/notifications.8cddcee5.svg";